const urlify = (name) => {
	// Replace diacritics
	const lookup = [
		/&/g, 'and',
		/[\300-\306]/g, 'A',
		/[\340-\346]/g, 'a',
		/\307/g, 'C',
		/\347/g, 'c',
		/[\310-\313]/g, 'E',
		/[\350-\353]/g, 'e',
		/[\314-\317]/g, 'I',
		/[\354-\357]/g, 'i',
		/\321/g, 'N',
		/\361/g, 'n',
		/[\322-\330]/g, 'O',
		/[\362-\370]/g, 'o',
		/[\331-\334]/g, 'U',
		/[\371-\374]/g, 'u',
	];

	for (let i = 0; i < lookup.length; i += 2) {
		name = name.replace(lookup[i], lookup[i + 1]);
	}

	// Replace whitespace
	name = name.replace(/\s+/g, '-');

	// Remove anything else
	name = name.replace(/[^a-z0-9_-]+/gi, '').toLowerCase();

	return name;
};

const deCamel = (string) => {
	const newString = string.replace(/[a-z0-9](?=[A-Z])/g, v => `${v} `);
	return newString.charAt(0).toUpperCase() + newString.slice(1);
};

const titleCase = (string) => {
	const newString = string.toLowerCase().replace(/(\s|-|_)\S/g, v => v.toUpperCase());
	return newString.charAt(0).toUpperCase() + newString.slice(1);
};

const camelCase = (string) => {
	const newString = titleCase(string).replace(/(\s|-|_)/g, '');
	return newString.charAt(0).toLowerCase() + newString.slice(1);
};

const formatPrice = (price, format) => {
	if (format.indexOf('amount_no_decimals') !== -1) {
		price = price.replace(/\.\d*/, '');
	}
	if (format.indexOf('amount') !== -1) {
		if (!/\.\d\d$/.test(price)) {
			price = `${price}.00`;
		} else if (/\.\d$/.test(price)) {
			price = `${price}0`;
		}
	}
	return format.replace(/\{\{.*\}\}/, price);
};

export { urlify, deCamel, camelCase, titleCase, formatPrice };



// WEBPACK FOOTER //
// ./utils/string.js